import type React from "react";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const titleId = useId();

  const handleBackToHome = () => {
    // Public app -> protected route の遷移では認証ラッパーを確実に有効化するため、フルリロードする
    window.location.href = "/";
  };

  return (
    <main
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-rw-gray-150 px-4 py-10 sm:px-6 sm:py-12"
      aria-labelledby={titleId}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_15%,rgba(55,126,127,0.16),transparent_40%),radial-gradient(circle_at_85%_85%,rgba(12,69,82,0.14),transparent_40%)]"
      />

      <section className="relative z-10 w-full max-w-2xl rounded-2xl border border-rw-light-gray bg-white/95 px-6 py-10 text-center shadow-[0_16px_40px_rgba(15,38,48,0.12)] backdrop-blur-sm sm:px-10 sm:py-12">
        <div className="mx-auto flex w-fit items-center justify-center">
          <div className="border-rw-main/15 bg-rw-main/10 relative flex size-32 items-center justify-center rounded-full border p-4 sm:size-40">
            <img
              src="/notFound-image.jpg"
              alt={t("common.pageNotFound")}
              className="size-full object-contain"
            />
          </div>
        </div>
        <p className="mt-6 text-2xl font-semibold uppercase tracking-[0.22em] text-rw-main sm:text-3xl">
          404
        </p>
        <h1
          id={titleId}
          className="mt-2 text-2xl font-semibold text-rw-black-gray sm:text-3xl"
        >
          {t("common.pageNotFound")}
        </h1>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-rw-dark-gray sm:text-base">
          {t("common.pageNotFoundDescription")}
        </p>

        <div className="mt-8">
          <Button
            variant="teal"
            size="lg"
            className="w-full sm:w-auto"
            onClick={handleBackToHome}
          >
            {t("common.backToHome")}
          </Button>
        </div>
      </section>
    </main>
  );
};
